// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'box-4';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.188.56h-4.5C1.066.56.563 1.064.563 1.685v4.5c0 .622.503 1.125 1.125 1.125h4.5c.62 0 1.125-.503 1.125-1.125v-4.5c0-.621-.504-1.125-1.125-1.125zm0 10.125h-4.5c-.622 0-1.125.504-1.125 1.125v4.5c0 .622.503 1.125 1.125 1.125h4.5c.62 0 1.125-.503 1.125-1.125v-4.5c0-.621-.504-1.125-1.125-1.125zM16.313.56h-4.5c-.622 0-1.126.504-1.126 1.125v4.5c0 .622.504 1.125 1.126 1.125h4.5c.62 0 1.125-.503 1.125-1.125v-4.5c0-.621-.504-1.125-1.125-1.125zm0 10.125h-4.5c-.622 0-1.126.504-1.126 1.125v4.5c0 .622.504 1.125 1.126 1.125h4.5c.62 0 1.125-.503 1.125-1.125v-4.5c0-.621-.504-1.125-1.125-1.125z'
  />
);

export const viewBox = '0 0 18 18';
